import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '32'}
      height={props.height || '32'}
      viewBox="0 0 32 32"
      fill="none"
    >
      <mask
        id="mask0_12711_68134"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12711_68134)">
        <path
          d="M15.2275 28C14.9425 28 14.7056 27.9042 14.5167 27.7125C14.3278 27.5208 14.2333 27.2833 14.2333 27V21.5C14.2333 21.2167 14.3297 20.9792 14.5225 20.7875C14.7153 20.5958 14.9542 20.5 15.2392 20.5C15.5242 20.5 15.7611 20.5958 15.95 20.7875C16.1389 20.9792 16.2333 21.2167 16.2333 21.5V23.2667H27C27.2833 23.2667 27.5208 23.3631 27.7125 23.5558C27.9042 23.7486 28 23.9875 28 24.2725C28 24.5575 27.9042 24.7944 27.7125 24.9833C27.5208 25.1722 27.2833 25.2667 27 25.2667H16.2333V27C16.2333 27.2833 16.1369 27.5208 15.9442 27.7125C15.7514 27.9042 15.5125 28 15.2275 28ZM5 25.2667C4.71667 25.2667 4.47917 25.1703 4.2875 24.9775C4.09583 24.7847 4 24.5458 4 24.2608C4 23.9758 4.09583 23.7389 4.2875 23.55C4.47917 23.3611 4.71667 23.2667 5 23.2667H11.2333C11.5167 23.2667 11.7542 23.3631 11.9458 23.5558C12.1375 23.7486 12.2333 23.9875 12.2333 24.2725C12.2333 24.5575 12.1375 24.7944 11.9458 24.9833C11.7542 25.1722 11.5167 25.2667 11.2333 25.2667H5ZM11.2275 19.7333C10.9425 19.7333 10.7056 19.6375 10.5167 19.4458C10.3278 19.2542 10.2333 19.0167 10.2333 18.7333V17H5C4.71667 17 4.47917 16.9036 4.2875 16.7108C4.09583 16.518 4 16.2791 4 15.9942C4 15.7092 4.09583 15.4722 4.2875 15.2833C4.47917 15.0944 4.71667 15 5 15H10.2333V13.2C10.2333 12.9167 10.3297 12.6792 10.5225 12.4875C10.7153 12.2958 10.9542 12.2 11.2392 12.2C11.5242 12.2 11.7611 12.2958 11.95 12.4875C12.1389 12.6792 12.2333 12.9167 12.2333 13.2V18.7333C12.2333 19.0167 12.1369 19.2542 11.9442 19.4458C11.7514 19.6375 11.5125 19.7333 11.2275 19.7333ZM15.2333 17C14.95 17 14.7125 16.9036 14.5208 16.7108C14.3292 16.518 14.2333 16.2791 14.2333 15.9942C14.2333 15.7092 14.3292 15.4722 14.5208 15.2833C14.7125 15.0944 14.95 15 15.2333 15H27C27.2833 15 27.5208 15.0964 27.7125 15.2892C27.9042 15.482 28 15.7209 28 16.0058C28 16.2908 27.9042 16.5278 27.7125 16.7167C27.5208 16.9056 27.2833 17 27 17H15.2333ZM20.7608 11.5C20.4758 11.5 20.2389 11.4042 20.05 11.2125C19.8611 11.0208 19.7667 10.7833 19.7667 10.5V5C19.7667 4.71667 19.8631 4.47917 20.0558 4.2875C20.2486 4.09583 20.4875 4 20.7725 4C21.0575 4 21.2944 4.09583 21.4833 4.2875C21.6722 4.47917 21.7667 4.71667 21.7667 5V6.73333H27C27.2833 6.73333 27.5208 6.82972 27.7125 7.0225C27.9042 7.2153 28 7.45419 28 7.73917C28 8.02417 27.9042 8.26111 27.7125 8.45C27.5208 8.63889 27.2833 8.73333 27 8.73333H21.7667V10.5C21.7667 10.7833 21.6703 11.0208 21.4775 11.2125C21.2847 11.4042 21.0458 11.5 20.7608 11.5ZM5 8.73333C4.71667 8.73333 4.47917 8.63695 4.2875 8.44417C4.09583 8.25137 4 8.01248 4 7.7275C4 7.4425 4.09583 7.20556 4.2875 7.01667C4.47917 6.82778 4.71667 6.73333 5 6.73333H16.7667C17.05 6.73333 17.2875 6.82972 17.4792 7.0225C17.6708 7.2153 17.7667 7.45419 17.7667 7.73917C17.7667 8.02417 17.6708 8.26111 17.4792 8.45C17.2875 8.63889 17.05 8.73333 16.7667 8.73333H5Z"
          fill="#2BA168"
        />
      </g>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgTune = _style(SvgIcon)

export default SvgTune
